import moment from 'moment';
import type {ExchangeRate, RateStatus} from './types';

export const hasRateStarted = (startDate: string | null, today: moment.Moment): boolean =>
	startDate === null || !moment(startDate).isAfter(today, 'day');

export const hasRateEnded = (endDate: string | null, today: moment.Moment): boolean =>
	endDate !== null && moment(endDate).isBefore(today, 'day');

export const getRateStatus = (rate: ExchangeRate, today: moment.Moment): RateStatus => {
	if (!hasRateStarted(rate.startDate, today)) return 'upcoming';
	if (hasRateEnded(rate.endDate, today)) return 'past';
	return 'current';
};
